import React from 'react';
import { FaMoneyBillWave, FaSyncAlt, FaArrowRight } from 'react-icons/fa';
import { formatMoney, formatNum } from '../../../services/cadastral.service';
import styles from '../../../styles/Cadastral.module.css';

function Block({ title, icon: Icon, children }) {
  return (
    <div className={styles.block}>
      <div className={styles.blockTitle}>
        <span className={styles.btIco}><Icon size={13} /></span>
        {title}
      </div>
      {children}
    </div>
  );
}

export default function ValuationTab({ file }) {
  const previousValuation = file.previousAssessment;
  const valueChange = previousValuation ? file.cadastralValue - previousValuation.cadastralValue : 0;
  const percentageChange = previousValuation && previousValuation.cadastralValue
    ? (valueChange / previousValuation.cadastralValue) * 100
    : 0;

  return (
    <div className={styles.tabContentFade}>
      <Block title="Determinación del valor catastral" icon={FaMoneyBillWave}>
        <div className={styles.valSummary}>
          <div className={styles.valCard}>
            <div className={styles.vLbl}>A) Valor del terreno</div>
            <div className={styles.vNum}>{formatMoney(file.land.totalValue)}</div>
            <div className={styles.vSub}>
              {formatNum(file.land.area)} m² × {formatMoney(file.land.unitValue)} × {file.land.meritFactor.toFixed(6)}
            </div>
          </div>

          <div className={styles.valCard}>
            <div className={styles.vLbl}>B) Valor de las construcciones</div>
            <div className={styles.vNum}>{formatMoney(file.totalBuildingValue)}</div>
            <div className={styles.vSub}>
              {formatNum(file.totalBuildingArea)} m² en {file.buildings.length} partida(s)
            </div>
          </div>

          <div className={`${styles.valCard} ${styles.valTotal}`}>
            <div>
              <div className={styles.vLbl}>Valor catastral total A) + B)</div>
              <div className={styles.vSub}>Ejercicio fiscal {file.registry.fiscalYear}</div>
            </div>
            <div className={styles.vNum}>{formatMoney(file.cadastralValue)}</div>
          </div>
        </div>
      </Block>

      {file.isUpdated && previousValuation ? (
        <Block title="Comparativo antes y después de la actualización" icon={FaSyncAlt}>
          <div className={styles.compare}>
            <div className={styles.cmp}>
              <div className={styles.cLbl}>Valor catastral previo</div>
              <div className={styles.cNum}>{formatMoney(previousValuation.cadastralValue)}</div>
              <div className={styles.vSub}>
                {formatNum(previousValuation.landArea)} m² terreno · {formatNum(previousValuation.buildingArea)} m² construcción
              </div>
            </div>

            <div className={styles.arrow}>
              <FaArrowRight size={18} />
            </div>

            <div className={`${styles.cmp} ${styles.after}`}>
              <div className={styles.cLbl}>Valor catastral actualizado</div>
              <div className={styles.cNum}>{formatMoney(file.cadastralValue)}</div>
              <div className={styles.vSub}>
                {formatNum(file.land.area)} m² terreno · {formatNum(file.totalBuildingArea)} m² construcción
              </div>
            </div>
          </div>

          <div className={styles.delta}>
            Incremento de {formatMoney(valueChange)} ({percentageChange.toFixed(1)}%) derivado de la actualización catastral
          </div>

          <div className={`${styles.stateDetail} ${styles.stateWarn}`}>
            Se detectó superficie de construcción no reportada a la autoridad, actualizándose el valor conforme a los
            artículos 28, 30, 36 fracciones II, VI y VII, 37 y 39 de la <strong>Ley de Catastro para el Estado de Querétaro</strong>,
            y al artículo 44 inciso a) de la <strong>Ley de Hacienda de los Municipios del Estado de Querétaro</strong>.
          </div>
        </Block>
      ) : (
        <div className={`${styles.stateDetail} ${styles.stateOk}`}>
          El predio no presenta diferencias entre la superficie registrada en el padrón y la verificada mediante ortomosaico.
          No procede actualización de valores para el ejercicio fiscal {file.registry.fiscalYear}.
        </div>
      )}
    </div>
  );
}